import { fetchData } from "../utils/dataProvider";
import { DELETE, GET, POST } from "../utils/constants";

export type TMerchantsExportStatus =
  | "pending"
  | "processing"
  | "processed"
  | "error";

export interface IMerchantsExport {
  id: number;
  status: TMerchantsExportStatus;
  downloadUrl: string | null;
  rowCount: number | null;
  fileSizeKb: number | null;
  errorMessage: string | null;
  marketplaceNames: string[] | null;
  createdAt: string;
  updatedAt: string;
}

export interface IMarketplaceOption {
  id: number;
  name: string;
}

const BASE_URL = "/marketplaces/merchants/export";
const ADMIN_URL = `${BASE_URL}/admin`;

// ── Perfil marketplace ────────────────────────────────────────────────────────

export const createMerchantsExport = (): Promise<IMerchantsExport> =>
  fetchData<IMerchantsExport>({
    url: BASE_URL,
    method: POST,
  });

export const getMerchantsExports = (): Promise<IMerchantsExport[]> =>
  fetchData<IMerchantsExport[]>({
    url: BASE_URL,
    method: GET,
  });

export const deleteMerchantsExport = (id: number): Promise<void> =>
  fetchData({
    url: `${BASE_URL}/${id}`,
    method: DELETE,
  });

// ── Perfil interno ────────────────────────────────────────────────────────────

export const getMarketplacesForExport = (): Promise<IMarketplaceOption[]> =>
  fetchData<IMarketplaceOption[]>({
    url: `${ADMIN_URL}/marketplaces`,
    method: GET,
  });

export const createInternalMerchantsExport = (
  marketplaceIds: number[],
): Promise<IMerchantsExport> =>
  fetchData({
    url: ADMIN_URL,
    method: POST,
    body: { marketplaceIds },
  });

export const getInternalMerchantsExports = (): Promise<IMerchantsExport[]> =>
  fetchData<IMerchantsExport[]>({
    url: ADMIN_URL,
    method: GET,
  });

export const deleteInternalMerchantsExport = (id: number): Promise<void> =>
  fetchData({
    url: `${ADMIN_URL}/${id}`,
    method: DELETE,
  });
